<template>
  <ul
    class="el-pager"
    :style="computedStyle"
    @click="onPagerClick"
  >
    <template v-if="$attrs.simple">
      <span>{{ currentPage }}/{{ pageCount }}</span>
    </template>
    <template v-else>
      <li
        v-if="pageCount > 0"
        :class="{ active: currentPage === 1, disabled }"
        class="number"
      >
        1
      </li>
      <li
        v-if="showPrevMore"
        :class="[quickprevIconClass, { disabled }]"
        class="el-icon more btn-quickprev"
        @mouseenter="onMouseenter('left')"
        @mouseleave="quickprevIconClass = 'el-icon-more'"
      ></li>
      <li
        v-for="pager in pagers"
        :key="pager"
        :class="{ active: currentPage === pager, disabled }"
        class="number"
      >
        {{ pager }}
      </li>
      <li
        v-if="showNextMore"
        :class="[quicknextIconClass, { disabled }]"
        class="el-icon more btn-quicknext"
        @mouseenter="onMouseenter('right')"
        @mouseleave="quicknextIconClass = 'el-icon-more'"
      ></li>
      <li
        v-if="pageCount > 1"
        :class="{ active: currentPage === pageCount, disabled }"
        class="number"
      >
        {{ pageCount }}
      </li>
    </template>
  </ul>
</template>

<script type="text/babel">
export default {
  name: 'RtPager',

  props: {
    currentPage: Number,

    pageCount: Number,

    pagerCount: Number,

    disabled: Boolean
  },

  data () {
    return {
      current: null,
      showPrevMore: false,
      showNextMore: false,
      quicknextIconClass: 'el-icon-more',
      quickprevIconClass: 'el-icon-more'
    };
  },

  computed: {
    computedStyle () {
      let style = {};
      if (this.computedPagerCount === this.pagerCount) {
        style.flex = 'unset';
      }
      return style;
    },
    pagers () {
      // pagerCount页码按钮的数量(大于等于 5 且小于等于 21 的奇数)
      const pagerCount = this.pagerCount;
      // 按钮的一半数量
      const halfPagerCount = (pagerCount - 1) / 2;

      // 当前页码数
      const currentPage = Number(this.currentPage);
      // 总页数
      const pageCount = Number(this.pageCount);
      // 左边的more图标
      let showPrevMore = false;
      // 右边的more图标
      let showNextMore = false;
      // 如果总页码数大于要显示的页码按钮数量
      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true;
        }
        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true;
        }
      }

      const array = [];

      if (showPrevMore && !showNextMore) {
        const startPage = pageCount - (pagerCount - 2);
        for (let i = startPage; i < pageCount; i++) {
          // ...78910
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (let i = 2; i < pagerCount; i++) {
          // 1234...
          array.push(i);
        }
      } else if (showPrevMore && showNextMore) {
        const offset = Math.floor(pagerCount / 2) - 1;
        for (let i = currentPage - offset; i <= currentPage + offset; i++) {
          // ... 456 ...
          array.push(i);
        }
      } else {
        for (let i = 2; i < pageCount; i++) {
          array.push(i);
        }
      }

      this.showPrevMore = showPrevMore;
      this.showNextMore = showNextMore;

      return array;
    }
  },

  watch: {
    showPrevMore (val) {
      if (!val) this.quickprevIconClass = 'el-icon-more';
    },

    showNextMore (val) {
      if (!val) this.quicknextIconClass = 'el-icon-more';
    }
  },

  methods: {
    onPagerClick (event) {
      const target = event.target;
      if (target.tagName === 'UL' || this.disabled) {
        return;
      }

      let newPage = Number(event.target.textContent);
      const pageCount = this.pageCount;
      const currentPage = this.currentPage;
      const pagerCountOffset = this.pagerCount - 2;

      if (target.className.indexOf('more') !== -1) {
        if (target.className.indexOf('quickprev') !== -1) {
          newPage = currentPage - pagerCountOffset;
        } else if (target.className.indexOf('quicknext') !== -1) {
          newPage = currentPage + pagerCountOffset;
        }
      }

      /* istanbul ignore if */
      if (!isNaN(newPage)) {
        if (newPage < 1) {
          newPage = 1;
        }

        if (newPage > pageCount) {
          newPage = pageCount;
        }
      }

      if (newPage !== currentPage) {
        this.$emit('change', newPage);
      }
    },

    onMouseenter (direction) {
      if (this.disabled) return;
      if (direction === 'left') {
        this.quickprevIconClass = 'el-icon-d-arrow-left';
      } else {
        this.quicknextIconClass = 'el-icon-d-arrow-right';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// pager.vue?6ebfc6af